// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__cDK0S","description":"style_description__FmDwF","tags":"style_tags__1zb3_","name":"style_name__uJCnd"};